<template>
  <div class="cloudaccount-setup">
    <a-row type="flex" align="middle" class="cloudaccount-setup-header">
      <a-col flex="240px">
        <div>
          <a-input-search v-model="search" placeholder="搜索 云账号" style="width: 180px;margin: 8px;" allow-clear />
          <a-tooltip placement="top">
            <template slot="title">
              <span>添加云账号</span>
            </template>
            <a-button shape="circle" icon="plus" @click="createCloudAccount" />
          </a-tooltip>
        </div>
      </a-col>
      <a-col flex="auto">
        <div class="cloudaccount-description">
          <div  v-if="view.cloudaccount.status">
            <a-row type="flex">
              <a-col flex="360px" class="cloudaccount-description-item">
                <span>{{ "云账号名称" }}</span>
                <span>{{ view.cloudaccount.name || '-' }}</span>
              </a-col>
              <a-col flex="auto" class="cloudaccount-description-item">
                <span>{{ "Provider" }}</span>
                <span><icon :type="view.cloudaccount.provider.toLowerCase()" style="font-size: 16px;" />{{ $t(`providers.${view.cloudaccount.provider.toLowerCase()}`)}}</span>
              </a-col>
            </a-row>
            <a-row type="flex">
              <a-col flex="360px" class="cloudaccount-description-item">
                <span>{{ "状态" }}</span>
                <span><status :status="view.cloudaccount.status" statusModule="cloudaccount" /></span>
              </a-col>
              <a-col flex="auto" class="cloudaccount-description-item">
                <span>{{ "启用状态" }}</span>
                <span>{{ view.cloudaccount.enabled ? '是' : '否' }}</span>
              </a-col>
            </a-row>
          </div>
        </div>
      </a-col>
    </a-row>
    <a-row type="flex" class="cloudaccount-setup-content">
      <a-col flex="240px">
        <cloud-account-setup-list  class="cloudaccount-setup-content-item" @changeView="changeView" :search="search" />
      </a-col>
      <a-col flex="auto">
        <cloud-account-setup-details class="cloudaccount-setup-content-item" @changeView="changeView" :cloudaccount="view.cloudaccount" :viewname="view.name" />
      </a-col>
    </a-row>
  </div>
</template>

<script>
import CloudAccountSetupList from './sections/CloudAccountSetupList'
import CloudAccountSetupDetails from './sections/CloudAccountSetupDetails'

export default {
  name: 'CloudAccountGuide',
  components: {
    CloudAccountSetupList,
    CloudAccountSetupDetails,
  },
  data () {
    return {
      search: '',
      view: {
        name: 'CloudAccountSetupSummary',
        cloudaccount: {}, // cloudaccount
      },
    }
  },
  methods: {
    changeView (v) {
      this.view.name = v.name
      this.view.cloudaccount = v.data
    },
    createCloudAccount () {
      this.$router.push('/cloudaccount/create').then(() => {
        window.location.reload()
      })
    },
  },
}
</script>

<style lang="less" scoped>
@content-height: 460px;

.cloudaccount-setup {
  border: 1px solid #e8e8e8;

  .cloudaccount-setup-header {
    height: 80px;
    border-bottom: 1px solid #e8e8e8;

    .cloudaccount-description {
      width: 800px;
      margin-left: 12px;

      .cloudaccount-description-item {
        display: flex;
        padding: 8px 1px !important;

        span:first-child {
          margin-right: 0.5em;
          &::after {
            content: ':';
          }
        }
      }
    }
  }

  .cloudaccount-setup-content {
    height: @content-height;

    .cloudaccount-setup-content-item {
      position: absolute;
      width: 100%;
      height: @content-height;
    }
  }
}
</style>
